
import {Component, Input, OnInit, NgZone, ViewChild, ElementRef, EventEmitter, Output, OnChanges, SimpleChanges, AfterViewInit } from "@angular/core";
import { AlgebraKiTService } from "../../services/algebrakit.service";
import { AuthoredExercise } from "../../types/algebrakit.types";

declare const AlgebraKIT: any;

@Component({
    selector: "app-akit-exercise-editor",
    templateUrl: "./akit-exercise-editor.component.html",
    styleUrls: ["./akit-exercise-editor.component.less"],
    standalone: false
})
export class AkitExerciseEditorComponent implements OnInit, OnChanges, AfterViewInit {
    @ViewChild('container') containerElement: ElementRef;
    @ViewChild('preview') previewElement: ElementRef;

    _spec:AuthoredExercise;
    showPreview: boolean = false;

    renderPromise: Promise<void>;
    renderResolve: () => void; //to resolve promise after render

    @Input() set spec(value: AuthoredExercise) {
        this._spec = value;
        this.setSpec();
    }
    
    get editorElm() {
        return  this.containerElement
            ?this.containerElement.nativeElement.getElementsByTagName('akit-exercise-editor')[0]
            :null;
    }

    constructor(
        private akitService: AlgebraKiTService,
        private _ngZone: NgZone
    ) {}

    ngOnInit() {
        this.setSpec();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.setSpec();
    }

    ngAfterViewInit() {
        return this.setSpec();
    }

    setSpec() {
        if(this._spec && this.editorElm) {
            AlgebraKIT.waitUntilReady(this.editorElm).then(() => {
                return this.editorElm.updateExercise(this._spec);
            }).then(() => this.showPreview = true);
        }
    }

    testExercise() {
        this.previewElement.nativeElement.run();
    }

    clearExerciseClicked() {
        this.akitService.createEmptyExercise().then(_ex => {
            this._spec = _ex;
            this.setSpec();
            this.showPreview = false;
            return this.waitForRender();
        }).then(() => {
            this.showPreview = true;
        })
    }

    waitForRender(): Promise<void> {
        if (!this.renderPromise) {
            this.renderPromise = new Promise((resolve, reject) => {
                this.renderResolve = resolve;
            });
        }
        return this.renderPromise;
    }

}
